import { useState } from 'react';
import { storage, StorageKeys } from '@/utils/storage';

export interface AppSettings {
  lowStockThreshold: number;
}

const DEFAULTS: AppSettings = {
  lowStockThreshold: 10,
};

function read(): AppSettings {
  const raw = storage.get(StorageKeys.APP_SETTINGS);
  if (!raw) return DEFAULTS;
  try {
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return DEFAULTS;
  }
}

/** Read/write app-level UI preferences stored in localStorage. */
export function useAppSettings() {
  const [settings, setSettings] = useState<AppSettings>(read);

  const update = (patch: Partial<AppSettings>) => {
    const next = { ...settings, ...patch };
    setSettings(next);
    storage.set(StorageKeys.APP_SETTINGS, JSON.stringify(next));
  };

  return { settings, update };
}
